import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=880cf3d0&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=880cf3d0&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Footer.vue?vue&type=style&index=2&id=880cf3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880cf3d0",
  null
  
)

export default component.exports